// extracted by mini-css-extract-plugin
module.exports = {"container":"FullDealTermSlider_container__AE6xW","slider":"FullDealTermSlider_slider__RGQmn"};